import { createAsyncThunk } from '@reduxjs/toolkit'
import { getMessageInfo, getMessageUnreadInfo } from 'services/module/message'
import { basePublicKey, getProfileInfo, logout } from 'services/module/user'
import { getUserAssets, userCabitalBalances, userCabitalInfo } from 'services/module/user/assets'
import { UserAssetsBalanceResModel, UserCabitalInfoResModel } from 'services/types/User'

export const setProfileInfo = createAsyncThunk('user/setProfileInfo', (params, thunkAPI) => {
  return getProfileInfo()
})

export const logoutThunk = createAsyncThunk('user/logout', (params, thunkAPI) => {
  return logout()
})

export const initPublicKey = createAsyncThunk('base/public/key', (params, thunkAPI) => {
  return basePublicKey()
})

export const setUserAssets = createAsyncThunk('assets/account-balance', (params, thunkAPI) => {
  return getUserAssets()
})

export const setMessageInfo = createAsyncThunk('message/v1/info', (params, thunkAPI) => {
  return getMessageInfo()
})

export const setMessageUnreadInfo = createAsyncThunk('message/unread/v1/info', (params, thunkAPI) => {
  return getMessageUnreadInfo()
})

export const setUserCabitalInfo = createAsyncThunk('user/cabital/link/info', async (params, thunkAPI) => {
  const result: { cabitalInfo: UserCabitalInfoResModel; cabitalBalances: Array<UserAssetsBalanceResModel> } = {
    cabitalInfo: {
      linked: false,
      otpReady: false,
      kyc: false,
      email: '',
      linkUrl: '',
    },
    cabitalBalances: [],
  }
  const cabitalInfo = await userCabitalInfo()
  if (cabitalInfo.code === 200) {
    result.cabitalInfo = cabitalInfo.data
    result.cabitalInfo.fetched = true
    if (cabitalInfo.data.kyc && cabitalInfo.data.linked && cabitalInfo.data.otpReady) {
      const cabitalBalances = await userCabitalBalances()
      if (cabitalBalances.code === 200) {
        result.cabitalBalances = cabitalBalances.data
      }
    }
  }
  return result
})
